import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  TripPlaceToCenterRequest,
  TripPlaceToCenterRequestBasic,
  TripPlaceToCenterRequestFilter,
  TripPlaceToCenterRequestLight,
  TripPlaceToCenterRequestPartial
} from '../../lib/types/models/trip-place-to-center-request/trip-place-to-center-request'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type TripPlaceToCenterRequestMappingType = {
  BASIC: TripPlaceToCenterRequestBasic
  LIGHT: TripPlaceToCenterRequestLight
  PARTIAL: TripPlaceToCenterRequestPartial
  FULL: TripPlaceToCenterRequest
}

export function getTripBookingTripPlaceToCenterRequests<
  T extends keyof TripPlaceToCenterRequestMappingType
>(id: number, options?: PaginationRequest<TripPlaceToCenterRequestFilter>) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<TripPlaceToCenterRequestFilter>>(
        constructApiUrl(API['trip-bookings'].getTripBookingTripPlaceToCenterRequests.url, { id }),
        options
      )
    )
    .get<PaginationResponse<TripPlaceToCenterRequestMappingType[T]>>()
}
